exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".video {\n  height: 325px;\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n@media only screen and (max-width: 1200px) {\n  .video {\n    margin-bottom: 5px;\n  }\n}\n", ""]);

